<template>
  <div class="multi_info">
    <div class="tabulation">
      <div class="tabulation_left">
        <component
          :is="getLinkComponent(showObject)"
          v-bind="getLinkAttrs(showObject)"
          target="_blank"
          class="item"
        >
          <img
            :src="showObject.image"
            class="img-hover"
            alt=""
          >
        </component>
      </div>
      <div class="tabulation_right">
        <div class="content">
          <div class="title">
            <component
              :is="getLinkComponent(showObject)"
              v-bind="getLinkAttrs(showObject)"
              target="_blank"
              class="item"
            >
              <!--              {{ showObject.title }}-->
              <span v-if="highlightText" v-html="highlightMatch(showObject.title)"></span>
              <span v-else>{{ showObject.title }}</span>
            </component>
            <div class="noCollect" v-if="showObject.isFavorite === '0'" @click="clickStar('2')"></div>
            <div class="collect" v-else @click="clickStar('3')"></div>
          </div>
          <div class="label">
            <a-button :title="val" class="button_submit" v-for="(val, index1) in showObject.mark" :key="'val' + index1">
              {{ val }}
            </a-button>
          </div>
          <div class="describe" :title="showObject.introduction">
            <!--            {{ showObject.introduction }}-->
            <span v-if="highlightText" v-html="highlightMatch(showObject.introduction)"></span>
            <span v-else>{{ showObject.introduction }}</span>
          </div>
          <div class="content_list">
            <ul>
              <li>
                <div>{{ showObject.bonus }}</div>
                <span>{{ globalDataArray.siteTemplateLanguage.competition_bonus }}</span>
              </li>
              <li>
                <div>{{ showObject.teams > 999 ? '999+' : showObject.teams }}</div>
                <span class="team_num">{{ teamCountText }} </span>
              </li>
              <li>
                <div>{{ showObject.categoryTitle }}</div>
                <span>{{ globalDataArray.siteTemplateLanguage.category_select }}</span>
              </li>
              <li>
                <div>{{ showObject.localEndtime ? showObject.localEndtime.substring(0, 10) : '-' }}</div>
                <span>{{ globalDataArray.siteTemplateLanguage.competition_end_signup }}<span class="utc8"> UTC+8</span></span>
              </li>
            </ul>
            <div class="cup" :class="showObject.signup === '04' ? 'active' : ''"></div>
          </div>
          <div class="construction">
            <div class="construction_left">
              <span class="bottom_span bottom_spanEn">{{ globalDataArray.siteTemplateLanguage.competition_co_builder }}:</span>
              <div>
                <template v-if="showObject.organizersLogo">
                  <span class="img" v-for="(val, index1) in showObject.organizersLogo" :key="'organizersLogo' + index1"><img :src="val" alt=""></span>
                </template>
                <template v-else>
                  <span class="txt" v-if="showObject.organizers?.[0]" :title="showObject.organizers[0]">{{ showObject.organizers[0] }}</span>
                </template>
              </div>
            </div>
            <div class="construction_right" v-if="!showObject.ccompetitions">
              <template v-if="showObject.signup === '04'">
                <a-button disabled class="button_ended">
                  {{ showObject.signup_dictText }}
                </a-button>
              </template>
              <template v-else-if="showObject.isSignup === '1'">
                <!-- 已经报名显示已报名 -->
                <a-button disabled class="button_started">
                  {{ globalDataArray.siteTemplateLanguage.competition_signup_yes }}
                </a-button>
              </template>
              <template v-else-if="showObject.signup === '00'">
                <!-- 不可报名 -->
                <a-button disabled class="button_ove">
                  {{ showObject.signup_dictText }}
                </a-button>
              </template>
              <template v-else-if="showObject.isSignup === '2'">
                <!-- 审核 -->
                <a-button class="button_ove">
                  {{ globalDataArray.siteTemplateLanguage.competition_signup_ing }}
                </a-button>
              </template>
              <template v-else-if="showObject.isSignup === '3'">
                <!-- 审核 -->
                <a-button class="button_ove">
                  {{ globalDataArray.siteTemplateLanguage.fail }}
                </a-button>
              </template>
              <template v-else>
                <template v-if="!isClient || currentTime < showObject.localEndtimeStr">
                  <!-- 未开始跟进行中 -->
                  <a-button class="a-button button_ended" v-if="showObject.signup === '01' || showObject.signup === '02'">
                    {{ showObject.signup_dictText }}
                  </a-button>
                  <!-- 已超限额 -->
                  <a-button disabled class="button_ove" v-else-if="showObject.isSignup === '10'">
                    {{ globalDataArray.siteTemplateLanguage.competition_signup_button_limit }}
                  </a-button>
                  <!-- 报名中 -->
                  <a-button
                    class="button_application" @click="toSignFun(showObject.templateId, showObject.categoryId, showObject.parentId, showObject.teamsUsers, showObject.teams, showObject.parentId, showObject.zoneId, showObject.agreementId, showObject.noticeId, showObject.qrImage)"
                    v-else-if="showObject.signup === '03'"
                  >
                    {{ globalDataArray.siteTemplateLanguage.click_signup }}
                  </a-button>
                </template>
                <!-- 截止报名 -->
                <a-button disabled class="button_ove" v-else-if="isClient">
                  {{ globalDataArray.siteTemplateLanguage.competition_signup_end }}
                </a-button>
              </template>
            </div>
          </div>
          <div class="action-box" v-if="!showObject.ccompetitions">
            <div class="btn-box">
              <template v-if="showObject.signup === '04'">
                <a-button disabled class="button_ended">
                  {{ showObject.signup_dictText }}
                </a-button>
              </template>
              <template v-else-if="showObject.isSignup === '1'">
                <!-- 已经报名显示已报名 -->
                <a-button disabled class="button_started">
                  {{ globalDataArray.siteTemplateLanguage.competition_signup_yes }}
                </a-button>
              </template>
              <template v-else-if="showObject.signup === '00'">
                <!-- 不可报名 -->
                <a-button disabled class="button_ove">
                  {{ showObject.signup_dictText }}
                </a-button>
              </template>
              <template v-else-if="showObject.isSignup === '2'">
                <!-- 审核 -->
                <a-button class="button_ove">
                  {{ globalDataArray.siteTemplateLanguage.competition_signup_ing }}
                </a-button>
              </template>
              <template v-else-if="showObject.isSignup === '3'">
                <!-- 审核 -->
                <a-button class="button_ove">
                  {{ globalDataArray.siteTemplateLanguage.fail }}
                </a-button>
              </template>
              <template v-else>
                <template v-if="!isClient || currentTime < showObject.localEndtimeStr">
                  <!-- 未开始跟进行中 -->
                  <a-button class="a-button button_ended" v-if="showObject.signup === '01' || showObject.signup === '02'">
                    {{ showObject.signup_dictText }}
                  </a-button>
                  <!-- 报名中 -->
                  <a-button
                    class="button_application" @click="toSignFun(showObject.templateId, showObject.categoryId, showObject.parentId, showObject.teamsUsers, showObject.teams, showObject.parentId, showObject.zoneId, showObject.agreementId, showObject.noticeId, showObject.qrImage)"
                    v-else-if="showObject.signup === '03'"
                  >
                    {{ globalDataArray.siteTemplateLanguage.click_signup }}
                  </a-button>
                </template>
                <!-- 截止报名 -->
                <a-button disabled class="button_ove" v-else-if="isClient">
                  {{ globalDataArray.siteTemplateLanguage.competition_signup_end }}
                </a-button>
              </template>
            </div>
            <div class="cup" :class="showObject.signup === '04' ? 'active' : ''"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="subset" :class="showMore ? '' : 'show_more'">
      <div class="subset_left">
        <div class="set_left">
          <div v-for="(tag, index) in showObject.ccompetitions" :key="tag.id">
            <div v-if="index === 0" :style="{ height: dynamicHeight / 2 + 'px' }">
              <div class="vertical">
                <div class="line"></div>
              </div>
              <div class="horizontal">
                <div class="line"></div>
              </div>
            </div>
            <div v-else :style="{ height: dynamicHeight + 'px' }">
              <div class="vertical_new">
                <div class="line_new"></div>
              </div>
              <div class="horizontal">
                <div class="line"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="subset_right">
        <div ref="setLeft" class="subset_external" v-for="tag in showObject.ccompetitions" :key="tag.id">
          <div class="subset_content">
            <div class="sub_left">
              <component
                :is="getLinkComponent(tag)"
                v-bind="getLinkAttrs(tag)"
                target="_blank"
                class="item"
              >
                <!--                {{ tag.title }}-->
                <span v-if="highlightText" v-html="highlightMatch(tag.title)"></span>
                <span v-else>{{ tag.title }}</span>
              </component>
              <div class="label">
                <a-button :title="val" class="button_submit" v-for="(val, index1) in tag.mark" :key="'val' + index1">
                  {{ val }}
                </a-button>
              </div>
            </div>
            <div class="sub_right">
              <div class="deal">
                <ul>
                  <li>
                    <div>{{ tag.bonus }}</div>
                    <span>{{ globalDataArray.siteTemplateLanguage.competition_bonus }}</span>
                  </li>
                  <li>
                    <div>{{ tag.teams > 999 ? '999+' : tag.teams }}</div>
                    <span class="team_num">{{ teamCountText }}</span>
                  </li>
                  <li>
                    <div>{{ tag.endTime ? tag.endTime.substring(0, 10) : '-' }}</div>
                    <span>{{ globalDataArray.siteTemplateLanguage.competition_end_signup }}<span class="utc8"> UTC+8</span></span>
                  </li>
                </ul>
              </div>
              <div class="cup" :class="tag.signup === '04' ? 'active' : ''"></div>
              <div class="noCollect" v-if="tag.isFavorite === '0'" @click="clickStarChildern(tag.id, '2')"></div>
              <div class="collect" v-else @click="clickStarChildern(tag.id, '3')"></div>
            </div>
          </div>
          <div class="sub_button">
            <div class="button_left">
              <div>
                <span class="bottom_span bottom_spanEn">{{ globalDataArray.siteTemplateLanguage.competition_co_builder }}:</span>
                <template v-if="tag.organizersLogo">
                  <span class="img" v-for="(val, index1) in tag.organizersLogo" :key="'organizersLogo' + index1"><img :src="val" alt=""></span>
                </template>
                <template v-else>
                  <span class="txt" v-if="tag.organizers?.[0]" :title="tag.organizers[0]">{{ tag.organizers[0] }}</span>
                </template>
              </div>
            </div>
            <div class="button_right">
              <div class="status_button">
                <template v-if="tag.signup === '04'">
                  <a-button disabled class="button_ended zi_button">
                    {{ tag.signup_name }}
                  </a-button>
                </template>
                <template v-else-if="tag.isSignup === '1'">
                  <!-- 已经报名显示已报名 -->
                  <a-button disabled class="button_started zi_button">
                    {{ globalDataArray.siteTemplateLanguage.competition_signup_yes }}
                  </a-button>
                </template>
                <template v-else-if="tag.signup === '00'">
                  <!-- 不可报名 -->
                  <a-button disabled class="button_ove">
                    {{ tag.signup_name }}
                  </a-button>
                </template>
                <template v-else-if="tag.isSignup === '2'">
                  <!-- 申请中 -->
                  <a-button class="button_ove zi_button">
                    {{ globalDataArray.siteTemplateLanguage.competition_signup_ing }}
                  </a-button>
                </template>
                <template v-else-if="tag.isSignup === '3'">
                  <!-- 审核 -->
                  <a-button class="button_ove zi_button">
                    {{ globalDataArray.siteTemplateLanguage.fail }}
                  </a-button>
                </template>
                <template v-else>
                  <template v-if="currentTime < tag.localEndtimeStr">
                    <!-- 未开始跟进行中 -->
                    <a-button class="a-button button_ended zi_button" v-if="tag.signup === '01' || tag.signup === '02'">
                      {{ tag.signup_name }}
                    </a-button>
                    <!-- 报名中 -->
                    <a-button
                      class="button_application zi_button" @click="toSignFun(tag.templateId, tag.categoryId, tag.parentId, tag.teamsUsers, tag.teams, tag.parentId, tag.zoneId, tag.agreementId, tag.noticeId, tag.qrImage)"
                      v-else-if="tag.signup === '03'"
                    >
                      {{ globalDataArray.siteTemplateLanguage.click_signup }}
                    </a-button>
                  </template>
                  <!-- 截止报名 -->
                  <a-button disabled class="button_ove zi_button" v-else>
                    {{ globalDataArray.siteTemplateLanguage.competition_signup_end }}
                  </a-button>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div v-if="showObject.ccompetitions?.length > 1" class="ended">
        <div v-if="showMore"><span @click="clickCollapse"><img src="../../../assets/images/multic/expand.png">收起</span></div>
        <div v-else><span @click="clickCollapse"><img src="../../../assets/images/multic/collapse.png">展开</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  name: 'MultiCondtionInfoNew',
  props: {
    showObject: {
      type: Object,
      default: () => ({})
    },
    fromQuery: {
      type: String,
      default: ''
    },
    highlightText: {
      type: String,
      default: ''
    },
    currentTime: {
      type: Number,
      default: 0
    },
    isClient: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: '',
      showMore: false,
      dynamicHeight: 0,
      isMobile: false,
      heightCalculateTimer: null,
      isClicking: false
    }
  },
  computed: {
    // 计算团队数显示文本，在中文移动端下简化显示
    teamCountText() {
      const originalText = this.globalDataArray?.siteTemplateLanguage?.competition_teams || ''
      // 判断是否为中文且在移动端
      if (this.isMobile && originalText === '已报名团队数') {
        return '团队数'
      }
      return originalText
    }
  },
  watch: {
    'showObject.ccompetitions': {
      handler() {
        this.$nextTick(this.calculateDynamicHeight)
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.$nextTick(this.calculateDynamicHeight)
    this.checkMobileStatus()
    window.addEventListener('resize', this.checkMobileStatus)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobileStatus)
    // 清理定时器
    if (this.heightCalculateTimer) {
      clearTimeout(this.heightCalculateTimer)
    }
  },
  methods: {
    hasOutLink(item) {
      return !!(item && typeof item.outLink === 'string' && item.outLink.trim())
    },
    normalizeOutLink(outLink) {
      const link = outLink.trim()
      if (/^(https?:)?\/\//i.test(link)) {
        return link
      }
      return `https://${link}`
    },
    getLinkComponent(item) {
      return this.hasOutLink(item) ? 'a' : 'router-link'
    },
    getLinkAttrs(item) {
      if (this.hasOutLink(item)) {
        return {
          href: this.normalizeOutLink(item.outLink),
          rel: 'noopener noreferrer'
        }
      }

      return {
        to: this.getCompetitionUrl(item.parentId)
      }
    },
    // 构建赛题详情页跳转URL，包含zone_id参数（如果存在）
    getCompetitionUrl(parentId) {
      let url = `/competitionInfo?id=${parentId}`

      // 添加from参数
      if (this.fromQuery) {
        url += `&from=${this.fromQuery}`
      }

      // 添加zone_id参数（如果当前路由包含zone_id）
      if (this.$route.query.zone_id) {
        url += `&zone_id=${this.$route.query.zone_id}`
      }

      return url
    },
    // 检测是否为移动端
    checkMobileStatus() {
      this.isMobile = window.innerWidth <= 768
    },
    highlightMatch(text) {
      if (!this.highlightText || !text) return text
      // 转义正则特殊字符
      const safeText = this.highlightText.replace(/[.*+?^${}()|[\\]\\\\]/g, '\\$&')
      try {
        const regex = new RegExp(`(${safeText})`, 'g')
        return text.replace(regex, '<span class=\"highlight\">$1</span>')
      } catch (e) {
        return text
      }
    },
    calculateDynamicHeight() {
      // 添加防抖，避免频繁计算
      if (this.heightCalculateTimer) {
        clearTimeout(this.heightCalculateTimer)
      }

      this.heightCalculateTimer = setTimeout(() => {
        const setLeftElements = this.$refs.setLeft
        if (setLeftElements?.length > 0) {
          this.dynamicHeight = setLeftElements[0].clientHeight + 16
        } else {
          this.dynamicHeight = 0
        }
      }, 16) // 约1帧的时间
    },
    async clickStar(value) {
      // 防止连续点击
      if (this.isClicking) return
      this.isClicking = true

      setTimeout(() => {
        this.isClicking = false
      }, 300)

      try {
        let token = ''
        const saitiAccessInfo = Cookies.get('saiti_access_info')
        if (saitiAccessInfo != '' && saitiAccessInfo != undefined && saitiAccessInfo != null) {
          token = JSON.parse(saitiAccessInfo).token
        }
        if (token !== '' && token !== undefined) {
          // 已登录，构造收藏参数
          let newObj = {}
          if (this.showObject.ccompetitions?.length > 0) {
            newObj = {
              type: value,
              parentcompetitionld: this.showObject.id
            }
            const competitionIds = this.showObject.ccompetitions.map(c => c.id)
            newObj.competitionld = competitionIds.join(',')
          } else {
            newObj = {
              type: value,
              parentcompetitionld: this.showObject.id,
              competitionld: this.showObject.id
            }
          }

          // 触发收藏/取消收藏事件（由父组件处理实际请求）
          this.$emit('addBrowserAndBookmark', newObj, this.showObject)
        } else {
          this.handleLogin()
        }
      } catch (error) {
        console.error('登录验证失败:', error)
        this.$message.error('登录验证失败，请重试')
      }
    },
    handleLogin() {
      const redirectUrl = encodeURIComponent(location.href)
      Cookies.set('atom_redirect', redirectUrl, { domain: '.openatom.tech', expires: 180, path: '/', secure: true })
      location.href = this.logAuthUrl
    },

    // 报名
    toSignFun(templateId, categoryId, competitionId, teamsUsers, teams, parentId, zoneId, agreementId, noticeId, qrImage) {
      this.$emit('toSignFun', templateId, categoryId, competitionId, teamsUsers, teams, parentId, zoneId, agreementId, noticeId, qrImage)
    },

    // 子集收藏
    clickStarChildern(childId, value) {
      // 防止连续点击
      if (this.isClicking) return
      this.isClicking = true

      setTimeout(() => {
        this.isClicking = false
      }, 300)

      const newObj = {
        type: value,
        parentcompetitionld: this.showObject.id,
        competitionld: childId
      }
      this.$emit('addBrowserAndBookmark', newObj, this.showObject)
    },

    clickCollapse() {
      this.showMore = !this.showMore
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .highlight {
  color: #1281ff;
}

.multi_info {
  .active {
    visibility: visible !important;
  }

  font-family: AlibabaPuHuiTiR;
  margin-bottom: 20px;
  background-color: #ffffff;
  border-radius: 10px;
  border: solid 3px #ffffff;
  //padding: 2.8%;
  padding: 2.8% 2.8% 1% 2.8%;
  width: 100%;
  transition: all 0.4s;

  &:hover {
    box-shadow: 0px 0px 15px 0px rgba(16, 44, 68, 0.2);
  }

  .button_submit {
    margin-right: 12px;
    border: none;
    height: 30px;
    width: 98px;
    color: #fff;
    background-image: linear-gradient(90deg, #02edff 0%, #1281ff 100%), linear-gradient(#1281ff, #1281ff);
    background-blend-mode: normal, normal;
    border-radius: 15px;
    font-size: 14px;
    text-align: center;
    line-height: 30px;

    /* 垂直居中文字 */
    &:hover {
      border: none;
    }
  }

  .button_ended {
    background: #B3B3B3;
    border-radius: 20px;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
    line-height: 40px;
    /* 垂直居中文字 */
    //width: 112px;
    height: 40px;
    border: none;

    /* 如果不需要边框 */
    &:hover {
      border: none;
    }
  }

  .button_application {
    border: none;
    background-image: linear-gradient(-90deg, #eb9a3b 0%, #d3355d 50%, #3456cf 100%), linear-gradient(#1281ff, #1281ff);
    background-blend-mode: normal;
    border-radius: 20px;
    // width: 112px;
    height: 40px;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
    line-height: 40px;

    /* 垂直居中文字 */
    &:hover {
      border: none;
    }
  }

  .button_started {
    background: #B0CDF8;
    border-radius: 20px;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
    line-height: 40px;
    /* 垂直居中文字 */
    //width: 112px;
    height: 40px;
    border: none;

    /* 如果不需要边框 */
    &:hover {
      border: none;
    }
  }

  .button_ove {
    background: #E48482;
    border-radius: 20px;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
    line-height: 40px;
    /* 垂直居中文字 */
    //width: 112px;
    height: 40px;
    border: none;

    /* 如果不需要边框 */
    &:hover {
      border: none;
    }
  }

  .zi_button {
    line-height: 32px;
    height: 32px;
  }

  .tabulation {
    display: flex;

    .tabulation_left {
      user-select: none;
      overflow: hidden;
      width: 35.9%;
      border-radius: 4px;
      height: 100%;

      img {
        width: 100%;
        border-radius: 4px;
        object-fit: cover;
        transition: transform 0.3s;
        /* 添加过渡效果，使缩放平滑 */
        transform-origin: center center;
        /* 设置缩放中心点 */
        user-select: none;

        &:hover {
          transform: scale(1.08);
        }
      }
    }

    .tabulation_right {
      width: 64%;

      .content {
        margin-left: 4%;

        .title {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .item {
            width: 100%;
            font-weight: 700;
            font-size: 24px;
            color: #333333;
            line-height: 34px;

            &:hover {
              color: #1281ff;
            }
          }

          .collect {
            width: 24px;
            height: 24px;
            background-size: contain;
            cursor: pointer;
            background-image: url("../../../assets/images/multic/collect.png");
          }

          .noCollect {
            width: 24px;
            height: 24px;
            background-size: contain;
            cursor: pointer;
            background-image: url("../../../assets/images/multic/noCollect.png");
          }
        }

        .label {
          margin-top: 8px;
          height: 30px;
          overflow: hidden;

          ::v-deep .button_submit span {
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .describe {
          width: 91%;
          margin-top: 12px;
          font-size: 14px;
          color: #687389;
          line-height: 1.5;
          overflow: hidden;
          height: 3em;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          display: -webkit-box;
        }

        .content_list {
          display: flex;
          width: 100%;
          justify-content: space-between;
          margin-top: 8px;

          ul {
            display: flex;
            width: 100%;
            justify-content: space-between;

            //margin-top: 7%;
            li {
              flex: 1;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              text-align: center;
              position: relative;
              padding: 0 2%;
              overflow: hidden;

              //margin-left: -1%;
              //width: 25%;
              div {
                font-weight: 700;
                font-size: 20px;
                color: #565656;
                line-height: 30px;
              }

              span {
                font-size: 14px;
                color: #687489;
                line-height: 20px;
              }

              &:not(:last-child)::after {
                content: '';
                position: absolute;
                right: 0;
                top: 50%;
                transform: translate(50%, -50%);
                width: 1px;
                height: 40px;
                background-color: #E9EDF1;
              }

              //&:last-child {
              //  div {
              //    font-size: 20px;
              //    line-height: 20px;
              //  }
              //}
            }
          }

          .cup {
            margin-right: -10px;
            //height: 84px;
            width: 14%;
            background: url("../../../assets/images/ended2.gif") center no-repeat;
            background-size: contain;
            visibility: hidden; // 先隐藏掉奖杯
          }
        }

        .construction {
          display: flex;
          justify-content: space-between;
          margin-top: 12px;

          .construction_left {
            display: flex;
            flex: 1;

            div {
              display: inline-block;
              height: 30px;
              overflow: hidden;
            }

            .bottom_span {
              //width: 69px;
              line-height: 30px;
              margin-right: 10px;
              white-space: nowrap;
              flex-shrink: 0;
            }

            .bottom_spanEn {
              //width: 69px;
              line-height: 30px;
              margin-right: 10px;
              white-space: nowrap;
              flex-shrink: 0;
            }

            .img {
              height: 30px;
              display: inline-block;
              margin-right: 10px;
              margin-bottom: 10px;
            }

            .txt {
              line-height: 30px;
            }
          }
        }

        .action-box {
          display: none;

          .cup {
            width: 80px;
            height: 80px;
            background: url("../../../assets/images/ended4.gif") center no-repeat;
            background-size: contain;
            display: none;
          }
        }
      }
    }
  }

  .button_submit {
    margin-right: 12px;
    border: none;
    height: 30px;
    width: 98px;
    color: #fff;
    background-image: linear-gradient(90deg, #02edff 0%, #1281ff 100%), linear-gradient(#1281ff, #1281ff);
    background-blend-mode: normal, normal;
    border-radius: 15px;
    font-size: 14px;
    text-align: center;
    line-height: 30px;

    /* 垂直居中文字 */
    &:hover {
      border: none;
    }
  }

  .subset {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;

    .subset_left {
      width: 15%;

      .set_left {
        width: 80%;
      }

      .vertical {
        height: 100%;
        display: flex;
        justify-content: center;

        .line {
          width: 2px;
          height: 100%;
          background-color: #E9EDF1;
        }

        .line::before {
          content: '';
          display: block;
          width: 6px;
          height: 2px;
          background-color: #E9EDF1;
          margin-left: -2px;
        }
      }

      .vertical_new {
        height: 100%;
        display: flex;
        justify-content: center;

        .line_new {
          width: 2px;
          height: 100%;
          background-color: #E9EDF1;
        }
      }

      .horizontal {
        position: relative;

        .line {
          height: 2px;
          width: 50%;
          background-color: #E9EDF1;
          margin-left: 49%;
        }

        .line::after {
          position: absolute;
          top: -2px;
          content: '';
          display: block;
          width: 2px;
          height: 6px;
          background-color: #E9EDF1;
          margin-left: 50%;
        }
      }
    }

    .subset_right {
      width: 85%;

      .subset_external {
        background: #E9F1FB;
        border-radius: 10px;
        margin-bottom: 16px;
        padding: 2%;
      }

      .subset_content {
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;

        .sub_left {
          flex: 30%;

          .item {
            font-size: 20px;
            color: #333333;
            line-height: 27px;
          }

          .label {
            margin-top: 6px;
            margin-bottom: 4px;
            height: 30px;
            overflow: hidden;

            ::v-deep .button_submit span {
              display: block;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }

        .sub_right {
          display: flex;
          width: 55%;

          .deal {
            display: flex;
            width: 100%;
            justify-content: space-between;

            ul {
              display: flex;
              width: 100%;
              justify-content: space-around;

              li {
                flex: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                text-align: center;
                position: relative;
                overflow: hidden;

                //width: 33%;
                div {
                  font-weight: 700;
                  font-size: 18px;
                  color: #565656;
                  line-height: 30px;
                }

                span {
                  font-size: 14px;
                  color: #687489;
                  line-height: 20px;
                }

                &:not(:last-child)::after {
                  content: '';
                  position: absolute;
                  right: 0;
                  top: 50%;
                  transform: translate(50%, -50%);
                  width: 1px;
                  height: 40px;
                  background-color: #E9EDF1;
                }

                //&:last-child {
                //  div {
                //    font-size: 16px;
                //    line-height: 20px;
                //  }
                //}
              }
            }
          }

          .cup {
            width: 19%;
            background: url("../../../assets/images/ended4.gif") center no-repeat;
            background-size: contain;
            visibility: hidden;
          }

          .collect {
            width: 30px;
            height: 24px;
            background-size: contain;
            cursor: pointer;
            background-image: url("../../../assets/images/multic/collect.png");
          }

          .noCollect {
            width: 30px;
            height: 24px;
            background-size: contain;
            cursor: pointer;
            background-image: url("../../../assets/images/multic/noCollect.png");
          }
        }
      }

      .sub_button {
        display: flex;
        justify-content: space-between;

        .button_left {

          .bottom_span {
            line-height: 30px;
            margin-right: 12px;
            white-space: nowrap;
            flex-shrink: 0;
          }

          img {
            height: 30px;
          }
        }
      }
    }
  }

  .ended {
    position: relative;
    cursor: pointer;
    text-align: center;
    font-size: 16px;
    color: #1281FF;
    line-height: 22px;

    div {
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 43%);
      margin-top: -22px;
      padding-top: 20px;
    }

    img {
      width: 24px;
      margin-right: 12px;
    }
  }

  .show_more {
    max-height: 186px;
    overflow: hidden;
  }
}

@media screen and (max-width: 1024px) {
  .multi_info {

    .tabulation {
      .tabulation_right {
        .content {
          .title .item {
            font-size: 18px;
          }

          .content_list {
            ul li {

              //width: 50%;
              &:not(:last-child)::after {
                height: 35px;
              }

              &:last-child {
                div {
                  font-size: 14px;
                }
              }

              div {
                font-size: 18px;
                line-height: 22px;
              }
            }
          }

          .construction .construction_left .bottom_span {
            width: auto;
            min-width: 90px;
          }
        }
      }
    }

    .subset .subset_right .subset_content {
      .sub_left {
        .item {
          font-size: 18px;
        }
      }

      .sub_right {
        .deal ul li {
          div {
            font-size: 18px;
          }

          &:not(:last-child)::after {
            display: none;
          }

          &:last-child {
            div {
              font-size: 14px;
              line-height: 16px;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .multi_info {
    /* 添加整体稳定性优化 */
    will-change: auto;
    transform: translateZ(0);
    backface-visibility: hidden;

    .tabulation {
      flex-direction: column;

      .tabulation_left {
        width: 100%;
      }

      .tabulation_right {
        width: 100%;

        .content {
          .title .item {
            font-size: 16px;
          }

          .content_list {
            ul li {

              //width: 50%;
              div {
                font-size: 16px;
                line-height: 20px;
              }

            }

            ul li::after {
              width: 0 !important;
            }
          }

          .construction .construction_left .bottom_span {
            width: auto;
            min-width: auto;
          }
        }
      }
    }

    .subset .subset_right .sub_button {
      flex-direction: column;

      .button_left .txt {
        display: inline-block;
      }
    }

    .subset .subset_right .subset_content {
      position: relative;
      flex-direction: column;
      /* 添加优化，减少重新渲染 */
      will-change: auto;
      backface-visibility: hidden;

      .sub_left {
        width: 100%;
        padding-right: 30px;

        .item {
          font-size: 16px;
        }

        .label {
          display: none;
        }
      }

      .sub_right {
        width: 100%;
        /* 确保容器稳定 */
        min-height: 60px;

        .deal ul li {
          flex: none !important;
        }

        .deal ul li div {
          font-size: 12px !important;
          line-height: 30px !important;
        }

        .collect {
          position: absolute;
          top: 2px;
          right: 2px;
          width: 24px;
          height: 24px;
          /* 优化渲染性能 */
          will-change: auto;
          backface-visibility: hidden;
        }

        .noCollect {
          position: absolute;
          top: 2px;
          right: 2px;
          width: 24px;
          height: 24px;
          /* 优化渲染性能 */
          will-change: auto;
          backface-visibility: hidden;
        }
      }
    }

    .construction_right {
      display: none;
    }

    .tabulation .tabulation_right .content .content_list .cup {
      display: none !important;
    }

    .action-box {
      display: flex !important;
      margin-top: 10px;

      .btn-box {
        flex: 1;
      }

      .cup.active {
        display: block !important;
        margin-top: -40px;
      }
    }

  }
}
</style>
